import {
  Accordion,
  AccordionItem,
  Column,
  Dropdown,
  Row,
} from 'carbon-components-react';
import PublicImage from 'src/common/components/PublicImage';
import { StepProps } from '../../../lib/interfaces';
import '../Assessments/index.scss';
import { useEffect } from 'react';
import {
  defaultValues,
  segmentsTrack,
} from 'src/apps/solution-advisor/constants/default';
import { useSmallBreakpoint } from 'src/common/hooks/widgets/useBreakpoint';

const Step4 = ({ postObj, setPostObj, useTranslation }: StepProps) => {
  const connectivity = defaultValues('connectivity', useTranslation) || [];
  const connectivityVM = defaultValues('connectivityVM', useTranslation) || [];
  const connectivitycopy =
    defaultValues('connectivitycopy', useTranslation) || [];
  const connectivitycopyVM =
    defaultValues('connectivitycopyVM', useTranslation) || [];

  const onChangeCapacity = (e: any, key: string) => {
    postObj[key] = e;
    setPostObj((prevFlags: any) => {
      const updatedFlags = Object.assign({}, prevFlags, {
        [key]: e,
      });
      return updatedFlags;
    });
  };
  useEffect(() => {
    setPostObj((prevFlags: any) => {
      const updatedFlags = Object.assign(
        {
          physicalHosts: connectivity[2],
          virtualMachine: connectivityVM[2],
          localCopies: connectivitycopy[2],
          localVCopies: connectivitycopyVM[2],
        },
        prevFlags,
      );
      return updatedFlags;
    });
  }, []);

  const segment = (evtKey = '') => {
    segmentsTrack(evtKey, 'Assessment Step 4 Page');
  };
  const isSmall = useSmallBreakpoint('560px');

  return (
    <div className="bx--row fixHeight">
      <div className="bx--col-lg-8 bx--col-md-4 bx--col-sm-16 bx--col-padding border-lr p-t-14">
        <div className="slide_text">{useTranslation('step4_para')}</div>
        {isSmall && (
          <div className="bx--col-md-8 bx--col-sm-4 p-b-0 p-t-14">
            <PublicImage
              imgPath={'images/high--performance.svg'}
              widgetId="solution-advisor"
              width="100%"
              height="100%"
              alt="animation-image"
              className="screen small-screen"
            />
          </div>
        )}
        <Accordion
          size="sm"
          className="interactive-widget__accordion p-t-accordian p-t-16"
        >
          <AccordionItem
            title={useTranslation('step4_accordion_title1')}
            className="p-b-0"
            open
          >
            <div className="b-b-1">
              <Row>
                <Column sm={16} md={16} lg={16}>
                  <Dropdown
                    id="default"
                    size="sm"
                    light
                    direction={isSmall ? 'top' : 'bottom'}
                    titleText={useTranslation('step4_accordion_dd1')}
                    label={useTranslation('step4_choose_option')}
                    items={connectivity}
                    onChange={({ selectedItem }) => {
                      onChangeCapacity(selectedItem, 'physicalHosts');
                      segment('Physical Hosts Selected');
                    }}
                    selectedItem={postObj['physicalHosts']}
                    itemToString={(item) => (item ? item.text : '')}
                  />
                </Column>
              </Row>
            </div>
            <div className="bx--col-padding p-b-0">
              <Row>
                <Column sm={16} md={16} lg={16}>
                  <Dropdown
                    id="default"
                    size="sm"
                    light
                    direction="top"
                    titleText={useTranslation('step4_accordion_dd2')}
                    label={useTranslation('step4_choose_option')}
                    items={connectivityVM}
                    onChange={({ selectedItem }) => {
                      onChangeCapacity(selectedItem, 'virtualMachine');
                      segment('Virtual Machines Selected');
                    }}
                    selectedItem={postObj['virtualMachine']}
                    itemToString={(item) => (item ? item.text : '')}
                  />
                </Column>
              </Row>
            </div>
            <div className="bx--col-padding p-b-0">
              <Row>
                <Column sm={16} md={16} lg={16}>
                  <Dropdown
                    id="default"
                    size="sm"
                    light
                    direction="top"
                    titleText={useTranslation('step4_accordion_dd3')}
                    label={useTranslation('step4_choose_option')}
                    items={connectivitycopy}
                    onChange={({ selectedItem }) => {
                      onChangeCapacity(selectedItem, 'localCopies');
                      segment('Local copies daily per host Selected');
                    }}
                    selectedItem={postObj['localCopies']}
                    itemToString={(item) => (item ? item.text : '')}
                  />
                </Column>
              </Row>
            </div>
            <div className="bx--col-padding p-b-0">
              <Row>
                <Column sm={16} md={16} lg={16}>
                  <Dropdown
                    id="default"
                    size="sm"
                    light
                    direction="top"
                    titleText={useTranslation('step4_accordion_dd4')}
                    label={useTranslation('step4_choose_option')}
                    items={connectivitycopyVM}
                    onChange={({ selectedItem }) => {
                      onChangeCapacity(selectedItem, 'localVCopies');
                      segment(
                        'Local copies daily per Virtual Machine Selected',
                      );
                    }}
                    selectedItem={postObj['localVCopies']}
                    itemToString={(item) => (item ? item.text : '')}
                  />
                </Column>
              </Row>
            </div>
          </AccordionItem>
        </Accordion>
      </div>
      {!isSmall && (
        <div className="bx--col-lg-8 bx--col-md-4 bx--col-sm-16 p-t-14">
          <div className="bx--row">
            <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4 p-b-0">
              <PublicImage
                imgPath={'images/high--performance.svg'}
                widgetId="solution-advisor"
                width="100%"
                height="100%"
                className="screen"
                alt="animation-image"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Step4;
